import React, { Component, Fragment } from 'react';
import { VictoryChart, VictoryBar, VictoryLabel, VictoryAxis } from 'victory';
import { Link } from 'react-router-dom';

import SharePrice from '../../../components/Home/SharePrice';
import LatestNews from '../../../components/Home/LatestNews';

import './style.scss';

export default class Home extends Component {
    constructor() {
        super();
        this.state = {
            data: require('./data.json'),
        };
    }

    /**
     * Improve how bar charts look by setting the lower y domain to 99% of min
     * This means there's more "distance" between the y values of the items
     */
    getChartDomain = (...values) => {
        if (!values.every(v => typeof v === 'number')) return;
        const min = Math.min(...values);
        const max = Math.max(...values);
        return {
            y: [min * 0.99, max],
        };
    };

    getBarChartLabel = item => d => {
        const addStarSuffix = item.colAYear === '2020' && d.y === 0.28;
        let value = d.y;
        try {
            if (typeof value === 'number') {
                value = new Intl.NumberFormat('en-GB', { minimumFractionDigits: 1 }).format(value);
            }
        } catch (e) {}
        return '£' + value + 'm' + (addStarSuffix ? '*' : '');
    };

    render() {
        const { data } = this.state;
        return (
            <Fragment>
                <ul>
                    <li className="shareprice">
                        <h1>Share Price</h1>
                        <SharePrice />
                        <h1>Latest News</h1>
                        <LatestNews />
                    </li>
                    <li className="keyfacts">
                        <h1>Key Facts</h1>
                        <p className="figures-exclude"></p>
                        <ul className="keyfacts-home">
                            <li className="left">
                                <span>
                                    Revenue
                                    <span className="right">
                                        {data.keyfacts.revenue[0].percent}%
                                    </span>
                                </span>
                                <VictoryChart domainPadding={{ x: 60 }}>
                                    <VictoryBar
                                        data={[
                                            {
                                                x: data.keyfacts.revenue[0].yearA,
                                                y: data.keyfacts.revenue[0].valueA,
                                            },
                                            {
                                                x: data.keyfacts.revenue[0].yearB,
                                                y: data.keyfacts.revenue[0].valueB,
                                            },
                                        ]}
                                        barRatio={2.2}
                                        labels={this.getBarChartLabel(data.keyfacts.revenue[0])}
                                        style={{
                                            fontFamily: "'book', sans-serif",
                                            data: { fill: '#ffd900' },
                                            labels: { fill: 'black' },
                                        }}
                                        labelComponent={
                                            <VictoryLabel
                                                dy={50}
                                                style={{
                                                    fontFamily: "'book', sans-serif",
                                                    fontSize: '25px',
                                                }}
                                            />
                                        }
                                    />
                                    <VictoryAxis
                                        tickValues={[2018, 2019]}
                                        style={{
                                            tickLabels: {
                                                fontFamily: "'book', sans-serif",
                                                fontSize: 20,
                                                fill: '#ffd900',
                                            },
                                        }}
                                    />
                                </VictoryChart>
                            </li>
                            <li className="right">
                                <span>
                                    Profit before tax
                                    <span className="right">
                                        {data.keyfacts.profit[0].percent}%
                                    </span>
                                </span>
                                <VictoryChart domainPadding={{ x: 60 }}>
                                    <VictoryBar
                                        data={[
                                            {
                                                x: data.keyfacts.profit[0].yearA,
                                                y: data.keyfacts.profit[0].valueA,
                                            },
                                            {
                                                x: data.keyfacts.profit[0].yearB,
                                                y: data.keyfacts.profit[0].valueB,
                                            },
                                        ]}
                                        barRatio={2.2}
                                        labels={this.getBarChartLabel(data.keyfacts.profit[0])}
                                        style={{
                                            fontFamily: "'book', sans-serif",
                                            data: { fill: '#ffd900' },
                                            labels: { fill: 'black' },
                                        }}
                                        labelComponent={
                                            <VictoryLabel
                                                dy={50}
                                                style={{
                                                    fontFamily: "'book', sans-serif",
                                                    fontSize: '25px',
                                                }}
                                            />
                                        }
                                    />
                                    <VictoryAxis
                                        tickValues={[2018, 2019]}
                                        style={{
                                            tickLabels: {
                                                fontFamily: "'book', sans-serif",
                                                fontSize: 20,
                                                fill: '#ffd900',
                                            },
                                        }}
                                    />
                                </VictoryChart>
                            </li>
                            <li className="left employees">
                                <p>{data.keyfacts.employees}</p>
                                <i></i>
                                <span>Employees</span>
                                <Link to="/key-facts">More key facts</Link>
                            </li>
                            <li className="right territories">
                                <i></i>
                                <p>
                                    {data.keyfacts.territories}
                                    <span>Territories</span>
                                </p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </Fragment>
        );
    }
}
